import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResponseStatus } from '../../../../common';
import { LoggingService } from '../../../../shared/services/logging';
import { entityName } from './invoice-setup.data-service';
@Injectable()
export class InvoiceSetupInterceptor implements HttpInterceptor {
    /**
     *
     */
    constructor(private log: LoggingService) {}

    public intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Pass the cloned request instead of the original request to the next handle
        // return next.handle(clonedRequest)
        // return next.handle(req);
        return next.handle(req).pipe(
            // filter(resp => resp instanceof HttpResponse),
            // map(event => event as HttpResponse<ChangeSet<InvoiceSetup>>),
            map((event: any) => {
                if (event.url?.endsWith(`${entityName}s`)) {
                    event.body.changes = event.body?.changes.map(change => ({
                        ...change,
                        entities:
                            //INFO: this is needed by InvoiceSetupContainer when saving multiple entities to map the id property for ngrx-data
                            change.entities.map(item => ({
                                ...item,
                                id: item.Ibo_id,
                                Status: {
                                    StatusCode: ResponseStatus.Success,
                                    Message: 'Saved'
                                }
                            })) ?? event
                    })) as any;
                    this.log.verbose({
                        type: 'InvoiceSetupInterceptor:response:mapped',
                        event
                    });
                }
                return event;
            })
        );
    }
}
